import { render, staticRenderFns } from "./recordEdit.vue?vue&type=template&id=19706e80&scoped=true&"
import script from "./recordEdit.vue?vue&type=script&lang=js&"
export * from "./recordEdit.vue?vue&type=script&lang=js&"
import style0 from "./recordEdit.vue?vue&type=style&index=0&id=19706e80&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19706e80",
  null
  
)

export default component.exports